// extracted by mini-css-extract-plugin
export default {"container":"Product_container__i1-gz","pagination":"Product_pagination__MLt+f"};